import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import CentroDistribuicao from "../classes/CentroDistribuicao";
import CentroDataset from "../data/CentroDataset";
import { useTranslation } from "react-i18next";

export default function AutocompleteCentro2(props: AutocompleteCentroProps) {
    const { t } = useTranslation();
    const dataSet = new CentroDataset();
    const [value, setValue] = useState<string>(props.value);
    const [data, setData] = useState<CentroDistribuicao[]>([]);
    const [dataFilter, setDataFilter] = useState<CentroDistribuicao[]>([]);

    useEffect(() => {
        dataSet.ListarAtivos().then((result) => setData(result));
    }, [])

    useEffect(() => {
        dataSet.ListarAtivos().then((result) => setData(result));
    }, [])

    useEffect(() => {
        if (dataFilter !== null && dataFilter !== undefined && dataFilter.length === 1){
            localStorage.setItem("centroSel", String(dataFilter[0].centro));
        } else {
            if (dataFilter.length !== 1)
                localStorage.removeItem("centroSel");
        }
    }, [dataFilter])

    const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDataFilter(data.filter(f => f.centro.toString().startsWith(event.target.value)))
    }

    return (
        <>
            <Autocomplete
                freeSolo
                id="free-solo-2-demo"
                value={value}
                disableClearable
                options={data.map((option: any) => option.centro + ' - ' + option.nome)}
                onChange={(e) => {
                    setDataFilter(data.filter(f => (f.centro.toString() + ' - ' + f.nome) === String(e.currentTarget.textContent)));  
                }}
                onBlur={(e) => {
                    setDataFilter(data.filter(f => (f.centro.toString() + ' - ' + f.nome) === String(e.currentTarget.textContent)));  
                    props.onChange(String(dataFilter[0].centro));
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t("common.autoComplete.centro.label")}
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                        onChange={handlerOnChange}
                    />
                )}
            />
        </>
    )
}

interface AutocompleteCentroProps {
    onChange?:any
    value?: any
}
